import React from 'react'

import * as tf from '@tensorflow/tfjs';

import { TabContent, TabPane, Nav, NavItem, NavLink, Card, Button, CardTitle, CardText, Row, Col } from 'reactstrap';

import { Container, FormGroup, Label, Input} from 'reactstrap'
import classnames from 'classnames';
import buttons from './buttons.css'
// const model_style_inception =  require('saved_model_style_inception_js/model.json')


tf.ENV.set('WEBGL_PACK', false);  // This needs to be done otherwise things run very slow v1.0.4

class App extends React.Component {


  constructor(props) {
    super(props)
    this.state = {
      activeTab: '1',
      styleButtonDisabled: true,
      styleButtonText: 'Loading Model',
      styleRatio: 1,
      styleRatioRaw: 100,
      canvasText: 'NFT is waiting',
      imageContentSingle: 'images/mask-5.png',
      imageStyleSingle: 'images/mask-6.png',
      imageContentSingleName: 'mask-5',
      imageStyleSingleName: 'mask-6'
    }
    
    this.styleImg = React.createRef();
    this.contentImg = React.createRef()
    this.stylized = React.createRef()
    this.disableStyleButton = this.disableStyleButton.bind(this)
    this.enableStyleButton = this.enableStyleButton.bind(this)
    this.setActiveTab = this.setActiveTab.bind(this)
    this.loadMobileNetStyleModel = this.loadMobileNetStyleModel.bind(this)
    this.loadInceptionStyleModel = this.loadInceptionStyleModel.bind(this)
    this.loadOriginalTransformerModel = this.loadOriginalTransformerModel.bind(this)
    this.loadSeparableTransformerModel = this.loadSeparableTransformerModel.bind(this)
    this.setImageStyleSingle = this.setImageStyleSingle.bind(this)
    this.setImageContentSingle = this.setImageContentSingle.bind(this)
    this.setImageStyleCombinedA = this.setImageStyleCombinedA.bind(this)
    this.setImageStyleCombinedB = this.setImageStyleCombinedB.bind(this)
    this.setStyleRatio = this.setStyleRatio.bind(this)
    this.styleOnClick = this.styleOnClick.bind(this)
    this.startStyling = this.startStyling.bind(this)
    
    Promise.all([
      this.loadInceptionStyleModel(),
      this.loadOriginalTransformerModel()
      ]).then(([styleNet, transformNet]) => {
        console.log('Loaded styleNet');
        this.setState({styleNet: styleNet})
        this.setState({transformNet:transformNet})
        
        this.enableStyleButton('Stylize')
      

      });

  }

  setActiveTab = tab => {
    this.setState({activeTab: tab })
  }

  toggle = tab => {
    if(this.state.activeTab !== tab) this.setActiveTab(tab);
  }

  loadMobileNetStyleModel = async function() {
    if (!this.state.mobileStyleNet) {
      const model = await tf.loadGraphModel(
                 'saved_model_style_js/model.json');
      console.log(model)
      this.setState({styleNet: model }) 
            }

    return this.state.styleNet;
    }

    loadInceptionStyleModel = async function () {
      if (!this.state.inceptionStyleNet) {
        const model = await tf.loadGraphModel(
               'saved_model_style_inception_js/model.json');
        this.setState({styleNet: model})
            }

        return this.state.styleNet;
    }

    loadOriginalTransformerModel = async function () {
        if (!this.state.transformNet) {
          const model = await tf.loadGraphModel(
               'saved_model_transformer_js/model.json'
             );
          this.setState({transformNet: model})
          }

        return this.state.transformNet;
    }

    loadSeparableTransformerModel = async function () {
      if (!this.state.separableTransformNet) {
        const model = await tf.loadGraphModel(
               'saved_model_transformer_separable_js/model.json'
            );
           this.setState({transformNet: model})
       }
      
      return this.state.transformNet
    }

    // On change for content A
  setImageStyleSingle = function(event) {
      const src = 'images/' + event.target.value + '.png';
      this.setState({imageStyleSingleName: event.target.value })
      this.setState({imageStyleSingle: src })
  }

  // On change for content B
  setImageContentSingle = function(event) {
      console.log(event.target.value)
      const src = 'images/' + event.target.value + '.png';
      this.setState({imageContentSingleName: event.target.value })
      this.setState({imageContentSingle: src })

  }
    // On change for content A
  setImageStyleCombinedA = function(selectedValue) {
      const src = 'images/' + selectedValue + '.png';
      this.setState({imageStyleCombinedA: src })
  }
  setImageStyleCombinedB = function(selectedValue) {
      const src = 'images/' + selectedValue + '.png';
      this.setState({imageStyleCombinedB: src })
  }

  setStyleRatio = function(e){
    this.setState({styleRatioRaw: e.target.value})
    this.setState({styleRatio: e.target.value/100.})
  }

  disableStyleButton = function(buttonText) {
    this.setState({styleButtonDisabled: true})
    this.setState({styleButtonText: buttonText})
  }
  enableStyleButton = function(buttonText) {
    this.setState({styleButtonDisabled: false})
    this.setState({styleButtonText: buttonText})
  }

  styleOnClick = function(){
    this.disableStyleButton('Stylizing your NFT')
    this.startStyling().finally(()=>{
      console.log('ok')
      this.enableStyleButton('Stylize');
    })
  }

  startStyling = async function () {
    await tf.nextFrame();

    // this.styleButton.textContent = 'Generating 100D style representation';
    await tf.nextFrame();

    let bottleneck = await tf.tidy(() => {
      return this.state.styleNet.predict(tf.browser.fromPixels(this.styleImg.current).toFloat().div(tf.scalar(255)).expandDims());
    })
    if (this.state.styleRatio !== 1.0) {
      // this.styleButton.textContent = 'Generating 100D identity style representation';
      await tf.nextFrame();
      const identityBottleneck = await tf.tidy(() => {
        return this.state.styleNet.predict(tf.browser.fromPixels(this.contentImg.current).toFloat().div(tf.scalar(255)).expandDims());
      })
      const styleBottleneck = bottleneck;

      bottleneck = await tf.tidy(() => {
        const styleBottleneckScaled = styleBottleneck.mul(tf.scalar(this.state.styleRatio));
        const identityBottleneckScaled = identityBottleneck.mul(tf.scalar(1.0-this.state.styleRatio));
        return styleBottleneckScaled.addStrict(identityBottleneckScaled)
      })
      styleBottleneck.dispose();
      identityBottleneck.dispose();
    }
    // this.styleButton.textContent = 'Stylizing image...';
    await tf.nextFrame();
    const stylized = await tf.tidy(() => {
      return this.state.transformNet.predict([tf.browser.fromPixels(this.contentImg.current).toFloat().div(tf.scalar(255)).expandDims(), bottleneck]).squeeze();
    })
    await tf.browser.toPixels(stylized, this.stylized.current);
    bottleneck.dispose();  // Might wanna keep this around
    stylized.dispose();
  }

  render () {

    return (

      <div className='mt-5' id="style-transfer">
      <Input type="file" id="file-select" style={{'display': 'none'}} accept="image/x-png,image/gif,image/jpeg"/>

      <div id="mobile-warning" hidden className="alert alert-warning" role="alert">
      This site may have problems functioning on mobile devices. 
      Don't worry, you can still read the description below!
      </div>
      <div className="text-center">
      <h1> Demo </h1>
      </div>
              <TabContent activeTab={this.state.activeTab} id="myTabContent">
                 <TabPane tabId="1">
                 <Container>
                   <Row className = "my-4">
                     <Col className="mx-5 my-4 text-center">
                        <img ref={this.contentImg} id="content-img" className="centered frame" src={this.state.imageContentSingle} width="200" height="256"/>
                        <br/>

                        <br/>
                        <Input type="select" value={this.state.imageContentSingleName} onChange={this.setImageContentSingle} id="content-select" className="centered custom-select">
                           <option value="" disabled>Select content</option>
                          
                           <option value="mask-1">mask-1</option>
                           <option value="mask-2">mask-2</option>
                           <option value="mask-3">mask-3</option>
                           <option value="mask-4">mask-4</option>
                           <option value="mask-5">mask-5</option>
                            <option value="mask-6">mask-6</option>
                        </Input>
                     </Col>
                     <Col className="mx-5 my-4 text-center">
                        <img ref={this.styleImg} id="style-img" className="centered frame" crossorigin="anonymous" src={this.state.imageStyleSingle} width="200" height="256"></img>
                        <br/>
                        
                        <br/>
                        <Input type="select" value={this.state.imageStyleSingleName} onChange={this.setImageStyleSingle} id="style-select" class="centered custom-select">
                           <option value="" disabled>Select a style</option>
                           <option value="autoglyph-1">autoglyph-1</option>
                           <option value="autoglyph-2">autoglyph-2</option>
                           <option value="autoglyph-3">autoglyph-3</option>
                           <option value="autoglyph-4">autoglyph-4</option>
                           <option value="mask-1">mask-1</option>
                           <option value="mask-2">mask-2</option>
                           <option value="mask-3">mask-3</option>
                           <option value="mask-4">mask-4</option>
                           <option value="mask-5">mask-5</option>
                           <option value="mask-6">mask-6</option>
                          
                          
                        </Input>
                      </Col>
                      <Container>
                      <Row className="my-4 d-flex justify-content-center flex-start" >
                      <Col md={6} className="d-flex justify-content-center flex-start">
                      <canvas ref={this.stylized} id="stylized" className="centered thumbnail frame  mt-5"></canvas>
                      </Col>
                      </Row>
                      <Row className="my-4" className="d-flex justify-content-center flex-start">
                        <Col md={6}>
                        <Label for="stylized-img-ratio" className="d-block">Stylization Ratio</Label>
                        <Input type="range" onInput={this.setStyleRatio} min="0" max="100" value={this.state.styleRatioRaw} className="custom-range centered" id="stylized-img-ratio"/>
                        <br/>
                        </Col>
                      </Row>
                      </Container>
                      <Container>
                      <Row className="my-4 d-flex justify-content-center">
                        <Col md={5} className="text-center">
                        <Button theme={buttons} id="style-button" disabled={this.state.styleButtonDisabled} onClick={this.styleOnClick} className="btn rounded btn-primary w-100">

                        {this.state.styleButtonText}</Button>
                        </Col>
                      </Row>
                      </Container>
                    </Row>
                    </Container>
                    </TabPane>
              </TabContent>
           </div>
    );

  }
}
export default App;
